module.exports = __webpack_public_path__ + "img/logo.842eb596.png";